import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';

import * as actions from './actions';
import { actions as activityActions, utils as activityUtils } from './../activity';
import { CHARTS_DATA_PERIOD, CHARTS_NUMBER_OF_PERIODS } from './../activity/constants';
import { utils as tmUtils } from './../team-management';
import { actions as filtersActions } from './../filters';
import { actions as organizationActions } from './../organization';
import { actions as teamsActions } from './../teams';
import { operations as usersOperations } from './../users';

export const getInitialData = ({ username, organizationId }) => (dispatch) => {
  dispatch(actions.getInitialDataRequest());

  return Promise.all([
    dispatch(activityActions.getOrganizationActivity({
      orgId: organizationId,
      since: activityUtils.xDaysAgo(CHARTS_DATA_PERIOD * CHARTS_NUMBER_OF_PERIODS + 1),
    })),
    dispatch(teamsActions.getTeamList()),
    dispatch(organizationActions.getSamlSettings({ username })).catch((error) => error), // we don't want to break if there is no SSO setup
    dispatch(organizationActions.getOrganization({ organizationId })),
  ]).then(
    () => dispatch(actions.getInitialDataSuccess()),
    (error) => dispatch(actions.getInitialDataFailure(error, { skipErrorPage: true })),
  );
};

export const getInitialUserTable = (payload) => (dispatch, getState) => {
  dispatch(actions.getInitialUserTableRequest());
  const currentPage = getState().apps.teamManagement.users.getIn(['users', 'currentPage']);
  const allFilters = tmUtils.serializeFilters(getState().apps.teamManagement.users.get('selectedFilters'));
  const offset = (currentPage - 1) * PAGINATION_LIMIT;
  return Promise.all([
    dispatch(filtersActions.getFilters(payload)),
    dispatch(usersOperations.getAllUserListData({ offset, allFilters })),
    dispatch(teamsActions.getTeamList()),
  ])
    .then(() => {
      dispatch(actions.getInitialUserTableSuccess());
    })
    .catch((error) => {
      dispatch(actions.getInitialUserTableFailure(error));
      throw error;
    });
};
